// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateFamilyTreeSettingsMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  settings: Types.UpdateFamilyTreeSettingsInput;
}>;


export type UpdateFamilyTreeSettingsMutation = { __typename?: 'Mutation', updateFamilyTreeSettings: { __typename?: 'FamilyTreeSettings', showAge: boolean, showHiddenIndividuals: boolean, showNotes: boolean, showStateOfResidence: boolean } };

export type UpdateFamilyTreeNodeSettingsMutationVariables = Types.Exact<{
  clientProfileId: Types.Scalars['ID']['input'];
  settings: Types.UpdateFamilyTreeNodeSettingsInput;
}>;


export type UpdateFamilyTreeNodeSettingsMutation = { __typename?: 'Mutation', updateFamilyTreeNodeSettings: { __typename?: 'FamilyTreeNodeSettings', showIndividualOnTree: boolean, showNotesForIndividual: boolean } };

export const Operations = {
  Mutation: {
    UpdateFamilyTreeSettings: 'UpdateFamilyTreeSettings' as const,
    UpdateFamilyTreeNodeSettings: 'UpdateFamilyTreeNodeSettings' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateFamilyTreeSettingsDocument = gql`
    mutation UpdateFamilyTreeSettings($householdId: ID!, $settings: UpdateFamilyTreeSettingsInput!) {
  updateFamilyTreeSettings(householdId: $householdId, settings: $settings) {
    showAge
    showHiddenIndividuals
    showNotes
    showStateOfResidence
  }
}
    `;
export type UpdateFamilyTreeSettingsMutationFn = Apollo.MutationFunction<UpdateFamilyTreeSettingsMutation, UpdateFamilyTreeSettingsMutationVariables>;

/**
 * __useUpdateFamilyTreeSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFamilyTreeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFamilyTreeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFamilyTreeSettingsMutation, { data, loading, error }] = useUpdateFamilyTreeSettingsMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateFamilyTreeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFamilyTreeSettingsMutation, UpdateFamilyTreeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFamilyTreeSettingsMutation, UpdateFamilyTreeSettingsMutationVariables>(UpdateFamilyTreeSettingsDocument, options);
      }
export type UpdateFamilyTreeSettingsMutationHookResult = ReturnType<typeof useUpdateFamilyTreeSettingsMutation>;
export type UpdateFamilyTreeSettingsMutationResult = Apollo.MutationResult<UpdateFamilyTreeSettingsMutation>;
export type UpdateFamilyTreeSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFamilyTreeSettingsMutation, UpdateFamilyTreeSettingsMutationVariables>;
export const UpdateFamilyTreeNodeSettingsDocument = gql`
    mutation UpdateFamilyTreeNodeSettings($clientProfileId: ID!, $settings: UpdateFamilyTreeNodeSettingsInput!) {
  updateFamilyTreeNodeSettings(
    clientProfileId: $clientProfileId
    settings: $settings
  ) {
    showIndividualOnTree
    showNotesForIndividual
  }
}
    `;
export type UpdateFamilyTreeNodeSettingsMutationFn = Apollo.MutationFunction<UpdateFamilyTreeNodeSettingsMutation, UpdateFamilyTreeNodeSettingsMutationVariables>;

/**
 * __useUpdateFamilyTreeNodeSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFamilyTreeNodeSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFamilyTreeNodeSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFamilyTreeNodeSettingsMutation, { data, loading, error }] = useUpdateFamilyTreeNodeSettingsMutation({
 *   variables: {
 *      clientProfileId: // value for 'clientProfileId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateFamilyTreeNodeSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFamilyTreeNodeSettingsMutation, UpdateFamilyTreeNodeSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFamilyTreeNodeSettingsMutation, UpdateFamilyTreeNodeSettingsMutationVariables>(UpdateFamilyTreeNodeSettingsDocument, options);
      }
export type UpdateFamilyTreeNodeSettingsMutationHookResult = ReturnType<typeof useUpdateFamilyTreeNodeSettingsMutation>;
export type UpdateFamilyTreeNodeSettingsMutationResult = Apollo.MutationResult<UpdateFamilyTreeNodeSettingsMutation>;
export type UpdateFamilyTreeNodeSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFamilyTreeNodeSettingsMutation, UpdateFamilyTreeNodeSettingsMutationVariables>;